<template>
  <div>
    <div v-for="monthListEntry in monthList" :key="monthListEntry.month" class="mt-3">
      <div class="text-muted font-weight-bold small d-flex w-100">
        <div class="flex-grow-1">{{ monthListEntry.month }}</div>
        <div>{{ getTotalAdjustmentForMonth(monthListEntry.month) | price}}</div>
      </div>
      <div class="list-group">
        <div class="list-group-item"
             :key="adjustment.id"
             v-for="adjustment in monthListEntry.adjustments">
          <div class="d-flex small">
            <div class="text-muted flex-grow-1">{{ adjustment.createdTime | date }}</div>
            <div class="badge-pill badge-info">{{ adjustment.kpi }}</div>
          </div>
          <div class="d-flex">
            <div class="font-weight-bold flex-grow-1">
              {{ adjustment.title ? adjustment.title : 'kein Titel' }}
            </div>
            <div class="font-weight-bold"
                 :class="{'text-success': adjustment.value > 0, 'text-danger': adjustment.value < 0}">
              {{ adjustment.value | price }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const getMonth = (date) => {
  return date.month + '/' + date.year
}

export default {
  props: {
    adjustments: Array
  },
  computed: {
    monthList() {
      if (this.adjustments.length === 0)
        return []
      const res = []
      for (let adjustment of this.adjustments) {
        const month = getMonth(adjustment.createdTime)
        const idx = res.findIndex(e => e.month === month)
        if (idx < 0) {
          const adjustments = []
          adjustments.push(adjustment)
          res.push({
            month,
            adjustments: [adjustment]
          })
        } else {
          res[idx].adjustments.push(adjustment)
        }
      }
      return res
    }
  },
  methods: {
    getTotalAdjustmentForMonth(month) {
      const res = this.monthList
          .filter(entry => entry.month === month)[0]
          .adjustments
          .reduce((sum, entry) => sum + entry.value, 0)
      return res;
    }
  }
}
</script>
